import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import en from "./locales/en.json"
import pl from "./locales/pl.json"

let initialized = false

export function initPublicSiteI18n(locale) {
  const lng = locale === "pl" ? "pl" : "en"
  if (initialized) {
    if (i18n.language !== lng) i18n.changeLanguage(lng)
    return i18n
  }

  i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, pl: { translation: pl } },
    lng,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  })
  initialized = true
  return i18n
}

export default i18n
